/**
 * Import axios
 */
import axios from './common/axios';

/**
 * Export api
 */
export default {

    /**
     * Get all configurations
     */
    getAllConfigurations() {
        return axios.post('configurations')
    },

    /**
     * Get all sliders list
     */
    getAllSlidersList() {
        return axios.post('/sliders');
    },

    /**
     * Get news list
     * @param currentPage
     */
    getNewsList(currentPage) {
        return axios.post('/news', {
            currentPage: currentPage
        })
    },

    /**
     * Get news content by slug
     * @param slug
     * @returns {*}
     */
    getNews(slug) {
        return axios.post('/news/detail', {
            slug: slug
        })
    },

    /**
     * Get recruitment list
     */
    getAllRecruitmentList() {
        return axios.post('/recruitment');
    },
}
